import axios from "axios";
import config from "../config";
import authHeader from "./auth-header";
import { encodeQueryValue } from "./queryString";
import { withoutLegacyAuthority } from "./requestPayload";
import { catalogLegacyQuery, catalogListLimit, localCatalogAction } from "./catalogRequest";

const API_URL = config.API_URL;

const create = (values) => {
  const action = "afterlogin/pricetier/store";
  return axios.post(API_URL + action, withoutLegacyAuthority(values), { headers: authHeader() });
};

const update = (values) => {
  const data = withoutLegacyAuthority(values);
  if (data.gender && typeof data.gender === "object") data.gender = data.gender.value;
  const action = "afterlogin/pricetier/update/" + values.id;
  return axios.post(API_URL + action, data, { headers: authHeader() });
};

const view = (values) => {
  const sort = values && values.sort;
  const result = values && values.result ? values.result : '';
  let sortstring = "";
  if (sort) {
    let sortArray = [];
    Object.keys(sort).map(function (key, index) {
      return sortArray[index] = `sort[${key}]=${sort[key]}`;
    });
    if (sortArray.length > 0) {
      let jsort = sortArray.join("&");
      sortstring = jsort;
    }
  }
  let pagination = true;
  if(values){
    if(values.id){
      pagination = false;
    }
    if(values.option){
      pagination = false;
    }
    if(typeof values.pagination === "boolean"){
      pagination = values.pagination;
    }
  }
  const action = localCatalogAction("afterlogin/pricetier/view", values, sortstring);
  const data = {
    pagination: pagination, //true or false
    id: values && values.id ? values.id : "",
    result: result, //business_name,owner_name
    option: values && values.option ? values.option : ''
  };
  const limit = catalogListLimit(values);
  if (limit) data.limit = limit;
  return axios.post(API_URL + action, data, { headers: authHeader() });
};

const deleted = (values) => {
  const action = `afterlogin/pricetier/delete/${values.id}`;
  const data = {};
  return axios.post(API_URL + action, data, { headers: authHeader() });
};

const suggetionlist = (values) => {
  let q = typeof (values && values.q) === "string" ? values.q : catalogLegacyQuery(values, "q") || "";
  const encodedQ = encodeQueryValue(q);
  const action = localCatalogAction("afterlogin/pricetier/view", values, `q=${encodedQ}`);
  const data = {
    pagination: true, //true or false
    id: values && values.id ? values.id : "",
    apicall:'suggetion',
    q,
  };
  const limit = catalogListLimit(values);
  if (limit) data.limit = limit;
  return axios.post(API_URL + action, data, { headers: authHeader() });
};

const pricetierApiController = {
  create,
  update,
  view,
  deleted,
  suggetionlist,
};
export default pricetierApiController;
